import { useLocation } from 'react-router-dom';

const useGetToken = (): URLSearchParams => {
  return new URLSearchParams(useLocation().search);
};

export default useGetToken;
